import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { progress, useProgress } from "../lib/progress";
import { CheckIcon, ChevronRightIcon } from "./Icons";
import QuestionCard from "./QuestionCard";

function QuizWorkspace({ level, onNext, hasNext }) {
  const { t } = useTranslation();
  const { quiz, levelStats } = useProgress();
  const answers = quiz[level.id] || {};
  const [attempt, setAttempt] = useState(0);

  const total = level.questions.length;
  const answeredCount = Object.keys(answers).length;
  const correctCount = level.questions.filter((q, index) => answers[index] === q.answer).length;
  const finished = answeredCount === total;
  const firstAttempt = !levelStats[level.id]?.quizAttempts;

  useEffect(() => {
    if (!finished) return;
    progress.markSolved(level.id);
    if (firstAttempt && correctCount === total) progress.recordPerfectQuiz(level.id);
  }, [finished, firstAttempt, correctCount, total, level.id]);

  return (
    <section className="workspace workspace--quiz" aria-label={level.title}>
      <div className="quiz">
        {level.questions.map((question, index) => (
          <QuestionCard
            key={`${attempt}-${index}`}
            question={question}
            eyebrow={t("quiz.question", { index: index + 1, total })}
            answer={answers[index]}
            onAnswer={(option) => progress.answerQuestion(level.id, index, option)}
          />
        ))}

        {finished && (
          <div className="summary summary--success quiz__summary" role="status">
            <CheckIcon size={18} strokeWidth={2.5} />
            <div className="summary__text">
              <strong>{t("quiz.score", { correct: correctCount, total })}</strong>
            </div>
            <div className="summary__actions">
              <button
                type="button"
                className="button button--ghost button--small"
                onClick={() => {
                  progress.resetQuiz(level.id);
                  setAttempt(attempt + 1);
                }}
              >
                {t("quiz.retry")}
              </button>
              {hasNext && (
                <button type="button" className="button button--primary button--small" onClick={onNext}>
                  {t("level.next")}
                  <ChevronRightIcon />
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default QuizWorkspace;
